<template>
    <div class="load-circle">
        <div class="load-svg">
        	<div class="loading-circle"></div>
        </div>
        <!--<svg class="container" height="100" width="100" viewBox="-50 -50 100 100">-->
        <!--    <animateTransform attributeName="transform" type="rotate" values="0 0 0;360 0 0" dur="1s" repeatCount="indefinite"></animateTransform>-->
        <!--    <circle class="progress" cx="0" cy="0" r="40" stroke-width="5" stroke-linecap="round" stroke-dasharray="251" fill="none" stroke="#14A83B">-->
        <!--        <animate attributeName="stroke" values="#B7DA7C;#6CBD83;#45B5B8;#3FDEBA;#3587E7;" dur="1s" repeatCount="indefinite"></animate>-->
        <!--        <animate attributeName="stroke-dashoffset" values="251;51;251" dur="1s" keyTimes="0;0.5;1" repeatCount="indefinite"></animate>-->
        <!--        <animateTransform attributeName="transform" type="rotate" values="0 0 0;135 0 0;360 0 0" keyTimes="0;0.5;1" dur="1s"-->
        <!--                          repeatCount="indefinite"></animateTransform>-->
        <!--    </circle>-->
        <!--    <circle class="progress" cx="0" cy="0" r="20" stroke-width="5" stroke-linecap="round" stroke-dasharray="100 130" fill="none"-->
        <!--            stroke="#14A83B">-->
        <!--        <animate attributeName="stroke" values="#B7DA7C;#6CBD83;#45B5B8;#3FDEBA;#3587E7;" dur="1s" repeatCount="indefinite"></animate>-->
        <!--        <animate attributeName="stroke-dashoffset" values="100;10;100" dur="1s" keyTimes="0;0.5;1" repeatCount="indefinite"></animate>-->
        <!--        <animateTransform attributeName="transform" type="rotate" values="0 0 0;135 0 0;360 0 0" keyTimes="0;0.5;1" dur="1s"-->
        <!--                          repeatCount="indefinite"></animateTransform>-->
        <!--    </circle>-->
        <!--</svg>-->
    </div>
</template>

<script>
export default {
    name: 'componentLoading',
    data() {
        return {};
    },
    methods: {}
};
</script>

<style lang="less" scoped>
.load-circle {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0.1;
    .load-svg {
        width: 80%;
        height: 80%;
    }
}

.rect {
    transform-origin: center 10px; //矩形的中心坐标
}

.loading-circle {
    width: 100%;
    height: 100%;
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
    background-image:url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGNsYXNzPSJjb250YWluZXIiIGhlaWdodD0iMTAwIiB3aWR0aD0iMTAwIiB2aWV3Qm94PSItNTAgLTUwIDEwMCAxMDAiPjxhbmltYXRlVHJhbnNmb3JtIGF0dHJpYnV0ZU5hbWU9InRyYW5zZm9ybSIgdHlwZT0icm90YXRlIiB2YWx1ZXM9IjAgMCAwOzM2MCAwIDAiIGR1cj0iMXMiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIi8+PGNpcmNsZSBjbGFzcz0icHJvZ3Jlc3MiIHI9IjQwIiBzdHJva2Utd2lkdGg9IjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWRhc2hhcnJheT0iMjUxIiBmaWxsPSJub25lIiBzdHJva2U9IiMxNEE4M0IiPjxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9InN0cm9rZSIgdmFsdWVzPSIjQjdEQTdDOyM2Q0JEODM7IzQ1QjVCODsjM0ZERUJBOyMzNTg3RTc7IiBkdXI9IjFzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIvPjxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9InN0cm9rZS1kYXNob2Zmc2V0IiB2YWx1ZXM9IjI1MTs1MTsyNTEiIGR1cj0iMXMiIGtleVRpbWVzPSIwOzAuNTsxIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIvPjxhbmltYXRlVHJhbnNmb3JtIGF0dHJpYnV0ZU5hbWU9InRyYW5zZm9ybSIgdHlwZT0icm90YXRlIiB2YWx1ZXM9IjAgMCAwOzEzNSAwIDA7MzYwIDAgMCIga2V5VGltZXM9IjA7MC41OzEiIGR1cj0iMXMiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIi8+PC9jaXJjbGU+PGNpcmNsZSBjbGFzcz0icHJvZ3Jlc3MiIHI9IjIwIiBzdHJva2Utd2lkdGg9IjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWRhc2hhcnJheT0iMTAwIDEzMCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMTRBODNCIj48YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJzdHJva2UiIHZhbHVlcz0iI0I3REE3QzsjNkNCRDgzOyM0NUI1Qjg7IzNGREVCQTsjMzU4N0U3OyIgZHVyPSIxcyIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiLz48YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJzdHJva2UtZGFzaG9mZnNldCIgdmFsdWVzPSIxMDA7MTA7MTAwIiBkdXI9IjFzIiBrZXlUaW1lcz0iMDswLjU7MSIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiLz48YW5pbWF0ZVRyYW5zZm9ybSBhdHRyaWJ1dGVOYW1lPSJ0cmFuc2Zvcm0iIHR5cGU9InJvdGF0ZSIgdmFsdWVzPSIwIDAgMDsxMzUgMCAwOzM2MCAwIDAiIGtleVRpbWVzPSIwOzAuNTsxIiBkdXI9IjFzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIvPjwvY2lyY2xlPjwvc3ZnPg==");
}

.progress {
    stroke: #14A83B;
    animation: move 1s linear infinite;
}

.container {
    animation: container 1s linear infinite;
}

//给外框也加上旋转动画，两个旋转叠加，效果更自然
@keyframes container {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(270deg);
    }
}

@keyframes move { //在改变stroke-dashoffset的同时也让圆环旋转
    0% {
        stroke-dashoffset: 251px;
    }
    50% {
        stroke-dashoffset: calc(251px * 0.2);
        transform: rotate(135deg);
    }
    100% {
        stroke-dashoffset: 251px;
        transform: rotate(450deg);
    }
}
</style>
